module.exports = __webpack_public_path__ + "static/dmd-blackwhite-4a40fdbc20a4589db5b638c074ee59c3.png";